
import { formatDate, parseISODate } from '@/utils/date'
import { defineComponent } from 'vue'

/**
 * Card component for public reports
 */
export default defineComponent({
  name: 'PublicReportCard',
  props: {
    reportId: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    createdAt: {
      type: String,
      required: true
    },
    isRestricted: {
      type: Boolean,
      default: false
    },
    views: {
      type: Number,
      default: 0
    },
    hasEditAccess: {
      type: Boolean,
      required: true
    },
    hasExportAccess: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    formatDate,
    parseISODate
  }
})
